<template>
  <div class="form" :class="lang == 'ar' ? 'ar' : ''">

    <div class="top" :class="lang == 'ar' ? 'ar' : ''">
      <p class="nav_short" :class="lang == 'ar' ? 'arshort' : ''">
        <router-link to="/activity" class="back"></router-link>
      </p>
      <p class="nav_long" :class="lang == 'ar' ? 'arlong' : ''"></p>
    </div>

    <div class="formContent">
      <div class="formTitle">{{ $t("message.strid11") }}</div>
      <div class="item">
        <label class="label" for="">{{ $t("message.strid12") }}</label>
          <input
            type="number"
            class="zone_id"
            :placeholder="$t('message.strid13')"
            v-model="form.zone_id"
            @click="onfocus"
          />
      </div>
      <div class="item">
        <label class="label" for="">{{ $t("message.strid14") }}</label>
          <input
            type="number"
            :placeholder="$t('message.strid15')"
            v-model="form.role_id"
            class="role_id"
            @click="onfocus"
          />
      </div>
      <div class="item">
        <label class="label" for="">{{ $t("message.strid16") }}</label>
        <div class="exp">
          <select
            name="select"
            v-model="form.contact_type"
            class="contact_type"
            @click="onfocus"
          >
            <option value="">{{ $t("message.strid17") }}</option>
            <option :value="item.id" v-for="item in contact" :key="item">
              {{ item.name }}
            </option>
          </select>
          <input
            class="contact_data"
            :placeholder="$t('message.strid18')"
            type="text"
            v-model="form.contact_data"
            @click="onfocus"
          />
        </div>
      </div>
      <div class="item imgbox">
        <img :src="interceptFn(account_img)" alt="" />
      </div>
      <div class="formTitle">{{ $t("message.strid19") }}</div>

      <!-- 选择国家 -->
      <div class="item">
        <label class="label ex" for="">{{ $t("message.strid56") }}</label>
        <select
          name="select"
          v-model="form.country"
          class="country"
          @click="onfocus"
        >
          <option value="">{{ $t("message.strid55") }}</option>
          <option :value="item.id" v-for="item in countryData" :key="item">
            {{ item.name }}
          </option>
        </select>
      </div>

      <!-- 选择语言 -->
      <div class="item">
        <label class="label ex" for="">{{ $t("message.strid23") }}</label>
        <select
          name="select"
          v-model="form.nation"
          class="nation"
          @click="onfocus"
        >
          <option value="">{{ $t("message.strid23") }}</option>
          <option :value="item.name" v-for="item in nations" :key="item">
            {{ item.name }}
          </option>
        </select>
      </div>

      <div class="item" v-for="(item, index) in work" :key="index">
        <div class="exp plat">
          <select
            name="select"
            v-model="item.platform_type"
            class="platform_type"
            @click="onfocus"
          >
            <option value="" selected="selected">
              {{ $t("message.strid20") }}
            </option>
            <option
              :value="item.id"
              v-for="item in publish_platform"
              :key="item"
            >
              {{ item.name }}
            </option>
          </select>
          <div class="input_box">
            <input
              class="ex platform_data"
              :class="lang == 'ar' ? 'dataar' : 'datanoar'"
              :placeholder="$t('message.strid21')"
              type="text"
              v-model="item.platform_data"
              @click="onfocus"
            />
            <span class="delete_icon_platform" :class="lang == 'ar' ? 'ar' : 'noar'" :link-index="index" @click="onDeleteFn($event)">x</span>
          </div>
          <div class="input_box">
            <input
              class="ex channel_data"
              :class="lang == 'ar' ? 'dataar' : 'datanoar'"
              :placeholder="$t('message.strid54')"
              type="text"
              v-model="item.channel_data"
              @click="onfocus"
            />
            <span class="delete_icon_channel" :class="lang == 'ar' ? 'ar' : 'noar'" :link-index="index" @click="onDeleteFn($event)">x</span>
          </div>

        </div>

        <i @click="removeOne(index)">-</i>
      </div>
      <div class="item">
        <div class="addOne" :class="{grayadd: work.length >= 4}" @click="addOne">+</div>
        <p :class="{grayadd: work.length >= 4}">{{ $t("message.strid22") }}</p>
      </div>
      <div class="item txt">
        <span class="text">
          <span class="check" @click="check()">
            <div v-if="checkB"></div>
          </span>
          {{ $t("message.strid33") }}
          <a
            class="toprotocol"
            :href="'/protocol?activity_tag=' + activity_tag + '&lang=' + lang"
            target="_blank"
            >{{ $t("message.strid51") }}</a
          ></span
        >
      </div>
      <div class="saveBtn" @click="saveFn">{{ $t("message.strid34") }}</div>
    </div>
  </div>
</template>

<script>
import { applyConfig, apply, getErrorCode } from "@/proxy/index";

export default {
  data() {
    return {
      lang: "en",
      activity_tag: "",
      checkB: false,
      time: "",
      work: [
        {
          platform_type: "",
          platform_data: "",
          channel_data: "",
        },
      ],
      contact: [],
      publish_platform: [],
      nations: [],
      form: {
        zone_id: "",
        role_id: "",
        contact_type: "",
        contact_data: "",
        country: '',
        nation: "",
        works: [],
      },
      text: "ssss",
      showLoading: null,
      ercodeObj: {},   // 错误码
      pageHeight: 0,   // 页面高度
      deleteObj: {
        "delete_icon_platform": "platform_data",
        "delete_icon_channel": "channel_data"
      },
      countryData: []

    };
  },
  methods: {
    interceptFn (url) {
      return url ? url.split('?')[0] : url
    },
    getParam() {
      applyConfig({ lang: this.lang })
        .then((res) => {
          if (res.code == 0) {
            var data = res.data;
            this.contact = data.contact;
            this.nations = data.nation;
            this.countryData = data.country;
            this.publish_platform = data.publish_platform;
            this.account_img = data.account_img;
          }
        })
        .catch(() => {
          //
        });
    },
    check() {
      this.checkB = !this.checkB;
    },
    removeOne(index) {
      if (this.work.length == 1) {
        return;
      }
      this.work.splice(index, 1);
    },
    addOne() {
      if(this.work.length < 4) {
        let obj = {};
        obj.platform_type = "";
        obj.platform_data = "";
        obj.channel_data = "";
        this.work.push(obj);
      }
    },
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
    toProtocol() {
      this.$router.push({
        path: "/protocol",
        query: {
          activity_tag: this.activity_tag,
          lang: this.lang,
        },
      });
    },
    onfocus() {
    },

    onDeleteFn(e) {
      const classname = e.target.getAttribute("class").split(' ')[0], linkindex = e.target.getAttribute("link-index");
      this.work[linkindex][this.deleteObj[classname]] = '';
    },

    saveFn() {
      this.time = this.formatDate(new Date());
      for (let key in this.form) {
        const dom = document.querySelector("." + key);
        if (this.form[key]) {
          if(dom && dom.style.border) {
            dom.style.border = ''
          }
        }

        if (!this.form[key]) {
          if (key == 'nation' || key == 'country') {
            if (dom.offsetTop - this.pageHeight/2 > 0) {
              const top = dom.offsetTop - this.pageHeight/2;
              this.setTopFn(top);
            }
          } else {
            this.setTopFn();
          }

          dom.style.border = "1px solid #B90525";
          layer.open({
            content: this.$t("message.strid52"),
            skin: "msg",
            time: 2,
          });
          return;
        }

      }
      for (let keys in this.work) {
        let ele = this.work[keys];
        for (let i in ele) {
          const dom = document.querySelectorAll("." + i)[keys];
          if(ele[i]) {
            if(dom && dom.style.border) {
              dom.style.border = ''
            }
          }

          if (!ele[i]) {
            if (dom.offsetTop - this.pageHeight/2 > 0) {
              const top = dom.offsetTop - this.pageHeight/2;
              this.setTopFn(top);
            }
            dom.style.border = "1px solid #B90525";
            layer.open({
              content: this.$t("message.strid52"),
              skin: "msg",
              time: 2,
            });
            return;
          }

        }
      }

      if (this.checkB) {
        this.form.works = this.work;
        this.form = JSON.stringify(this.form);
        this.showLoading = layer.open({
            type: 2,
            shadeClose: false
        });
        apply({
          lang: this.lang,
          apply_time_cus: this.time,
          activity_tag: this.activity_tag,
          data: this.form,
        })
          .then((res) => {
            layer.close(this.showLoading);
            if (res.code == 0) {
              layer.open({
                content: this.$t("message.strid35"),
                skin: "msg",
                time: 2,
              });
              setTimeout(() => {
                this.$router.push({
                  path: "/details",
                  query: {
                    activity_tag: this.activity_tag,
                    lang: this.lang,
                  },
                });
              }, 1000);
            } else {
              this.form = JSON.parse(this.form);
              const tcode = this.ercodeObj[res.code] ? this.ercodeObj[res.code] : `Server Error(${res.code})`
              layer.open({
                content: tcode,
                skin: "msg",
                time: 2,
              });

            }
          })
          .catch(() => {
            //
            layer.close(this.showLoading);
            this.form = JSON.parse(this.form);
            layer.open({
              content: this.$t("message.strid53"),
              skin: "msg",
              time: 2,
            });
          });
      } else {
        // this.form = JSON.parse(this.form);
        layer.open({
          content: this.$t("message.strid52"),
          skin: "msg",
          time: 2,
        });
      }
      this.$mlog.visitLog({
        behavior: "click",
        type: 'activity_submit',
        lang: this.$i18n.locale,
        url: this.activity_tag
      })
    },

    getErrorCodeFn() {
      getErrorCode(this.lang).then(res=>{
        res.errcode.forEach(item => {
          this.ercodeObj[item.code] = item.lang;
        })
      }).catch(err => {
      })
    },

    // 页面滚动到相应位置
    setTopFn(top) {
      if (document.documentElement && document.documentElement.scrollTop) {
        document.documentElement.scrollTop = top ? top : 0;
      } else if (document.body) {
        document.body.scrollTop = top ? top : 0;
      }
    },

    getViewPort () {
      if(document.compatMode == "BackCompat") {   //浏览器嗅探，混杂模式
          return {
              width: document.body.clientWidth,
              height: document.body.clientHeight
          };
      } else {
          return {
              width: document.documentElement.clientWidth,
              height: document.documentElement.clientHeight
          };
      }
    },

  },
  created() {
    this.activity_tag = this.$route.query.activity_tag;
    this.lang = this.$route.query.lang;
    this.$i18n.locale = this.lang || 'en'
  },
  mounted() {
    this.setTopFn();
    this.getParam();
    this.getErrorCodeFn()
    this.pageHeight = this.getViewPort().height;

  },

};
</script>

<style lang="scss" scoped>
@import "@/assets/style/form.scss";
</style>
